const messages = {
  title: "Mein Postfach",
  desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
  newMessages: "Neue Nachrichten in deinem Postfach",
  link: "Nachrichten anzeigen",
  showMessages: "Nachrichten anzeigen",
  message: {
    sender: "Absender",
    thread: "Betreff",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Zurück zur Übersicht",
  time: {
    secondsAgo: "vor {time} Sekunden",
    minutesAgo: "vor {time} Minuten",
    hoursAgo: "vor {time} Stunden",
    daysAgo: "vor {time} Tagen",
  },
};

export default {
  messages,
};
